import React from 'react'

export default function PathNotFound() {
  return (
    <div className='mx-auto my-4'>404. The requested URL was not found on this server.</div>
  )
}
